import { PaxDto } from '@bandido/shared/dtos';
import { SALE_ORDER_ITEM_TYPE } from '@bandido/shared/constants';

const RUTERO_CART_ITEM_TYPES = [
  SALE_ORDER_ITEM_TYPE.Rail,
  SALE_ORDER_ITEM_TYPE.Buses,
  SALE_ORDER_ITEM_TYPE.Ferry,
  SALE_ORDER_ITEM_TYPE.Tours,
  SALE_ORDER_ITEM_TYPE.Circuits,
  SALE_ORDER_ITEM_TYPE.Transfers,
  SALE_ORDER_ITEM_TYPE.Cars,
  SALE_ORDER_ITEM_TYPE.Esims,
] as const;

type RuteroCartItemType = (typeof RUTERO_CART_ITEM_TYPES)[number];

// TODO: esto viene así de hotelFareMetada.. habrá que tocarlo en algún momento. ¯\_(ツ)_/¯
export const calculateAdultsAndMinors = (occupancies: Record<string, any>[]) => {
  const today = new Date();
  const adultAge = 18;

  let adults = 0;
  let minors = 0;

  const servicePaxes = occupancies?.reduce((result:  PaxDto[], { paxes }) => [
    ...result,
    ...paxes
  ], [] as PaxDto[]) || [];

  servicePaxes.forEach(pax => {
    const birthDate = new Date(pax.dob);
    const age = today.getFullYear() - birthDate.getFullYear();
    const isBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    const exactAge = isBirthdayPassed ? age : age - 1;

    if (exactAge >= adultAge) {
      adults++;
    } else {
      minors++;
    }
  });
  
  return { adults, minors };
};

export const isRuteroCartItemType = (itemType: string): boolean =>
  RUTERO_CART_ITEM_TYPES.includes(itemType as RuteroCartItemType);

export const canUseOrdinaryCartDelete = (itemType: string): boolean =>
  !isRuteroCartItemType(itemType);
